// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__CszKA","messages":"Chat_messages__3MfRZ","dateDivider":"Chat_dateDivider__pPY7Y"};